__turbopack_context__.v({
  "card": "card-module-scss-module__Nlsx6q__card",
  "card-bonus-header": "card-module-scss-module__Nlsx6q__card-bonus-header",
  "card-contract-duration-label": "card-module-scss-module__Nlsx6q__card-contract-duration-label",
  "card-contract-duration-list": "card-module-scss-module__Nlsx6q__card-contract-duration-list",
  "card-contract-duration-row": "card-module-scss-module__Nlsx6q__card-contract-duration-row",
  "card-cta-placeholder": "card-module-scss-module__Nlsx6q__card-cta-placeholder",
  "card-duration-toggle-placeholder": "card-module-scss-module__Nlsx6q__card-duration-toggle-placeholder",
  "card-header": "card-module-scss-module__Nlsx6q__card-header",
  "card-headline-placeholder": "card-module-scss-module__Nlsx6q__card-headline-placeholder",
  "card-link-placeholder": "card-module-scss-module__Nlsx6q__card-link-placeholder",
  "card-price": "card-module-scss-module__Nlsx6q__card-price",
  "card-price-headline-placeholder": "card-module-scss-module__Nlsx6q__card-price-headline-placeholder",
  "card-text-placeholder": "card-module-scss-module__Nlsx6q__card-text-placeholder",
  "card-text-placeholder-wrapper": "card-module-scss-module__Nlsx6q__card-text-placeholder-wrapper",
  "form": "card-module-scss-module__Nlsx6q__form",
  "placeholder": "card-module-scss-module__Nlsx6q__placeholder",
  "text-cta": "card-module-scss-module__Nlsx6q__text-cta",
  "wrapper": "card-module-scss-module__Nlsx6q__wrapper",
  "wrapper-top-offset": "card-module-scss-module__Nlsx6q__wrapper-top-offset",
});
